import React from "react";
import "./EmptyUserState.css";
import CommonLoaderBlue from "../../../../../../../../components/Loader/LoaderBlue";
import { Button } from "primereact/button";
export default function EmptyUserState({ setShowEditUser, isLoading }) {
  return (
    <div className="main-empty-container">
      {isLoading ? (
        <CommonLoaderBlue sizehere={20} color="royalblue" />
      ) : (
        <>
          <p>No recent users found. Add new users to see them here!</p>
          <Button
            onClick={() => setShowEditUser(true)}
            label="Add New User"
            className="nextbtn"
          />
        </>
      )}
    </div>
  );
}
